export class ForbiddenError extends Error {
  constructor() {
    super('Доступ запрещен, нет прав!');
    this.name = 'ForbiddenError';
  }
}
